var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundwave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 42,
    viewBox: "0 0 44 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 23.4599H3.80681C4.08006 23.4599 4.34141 23.5717 4.5301 23.7694L5.28359 24.5586C5.8216 25.1221 6.76886 24.8812 6.97222 24.1291L8.5336 18.3545C8.81456 17.3154 10.3137 17.3929 10.486 18.4554L11.6353 25.54C11.823 26.6973 13.5059 26.6424 13.6178 25.4753L14.9334 11.7592C15.0504 10.5396 16.8365 10.5595 16.9262 11.7815L18.2743 30.1461C18.364 31.3687 20.1513 31.3878 20.2671 30.1674L21.4674 17.5173C21.5803 16.3276 23.3075 16.3023 23.4552 17.4882L24.5855 26.5636C24.7275 27.7035 26.365 27.7438 26.5629 26.6123L27.7197 19.9974C27.9064 18.9298 29.4206 18.8804 29.6765 19.9335L30.9156 25.0329C31.1429 25.9685 32.4314 26.0739 32.8078 25.1876L33.9323 22.5395C34.2086 21.8887 35.0547 21.7224 35.5568 22.2203L37.2213 23.8708C37.4811 24.1283 37.8606 24.2235 38.2111 24.1191L40.2826 23.5016C40.3753 23.474 40.4715 23.4599 40.5683 23.4599H43",
    stroke: "#142533",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundwave);
export default __webpack_public_path__ + "static/media/Soundwave.bae901e345c72f49839faa66e75b02d2.svg";
export { ForwardRef as ReactComponent };